<template>
    <div class="button-message-editor" :key="renderId">
        <div class="text-editor-wrapper">
            <div class="text-editor">
                <TiptapEditor
                    :placeholder="$t('chatbotv2.enterYourMessage')"
                    :show-attributes="showAttributes === undefined || showAttributes === true"
                    :show-emoji="showEmoji === undefined || showEmoji === true"
                    v-model="clone.message"
                    :max-character-count="640"
                    :whatsapp-mode="whatsappMode"
                    :allowed-attributes="allowedAttributes"
                    :preview-mode="previewMode"
                />
            </div>
        </div>
        <div class="buttons-wrapper">
            <div class="button-item" v-for="(button, i) in clone.buttons" :key="button.id">
                <a-popover
                    :visible="editingButtonPopupVisibleMap[button.id]"
                    placement="left"
                    @visibleChange="(e) => visibleChange(button.id, e)"
                    trigger="click"
                    :key="button.id"
                    :overlayClassName="'no-padding'"
                >
                    <div slot="content">
                        <ActionButtonUpdater
                            v-model="clone.buttons[i]"
                            :on-completed="
                                () => {
                                    editingButtonPopupVisibleMap[button.id] = false;
                                }
                            "
                            :popup-visible="editingButtonPopupVisibleMap[button.id]"
                            :flattedDiagram="flattedDiagram"
                            :whatsapp-mode="whatsappMode"
                            :allowed-attributes="allowedAttributes"
                        />
                    </div>

                    <span
                        class="d-flex justify-content-center align-items-center w-100 h-100"
                        @click="openEditButtonPopup(button.id)"
                        >{{ button.title }}</span
                    >
                    <div class="button-controls" v-if="clone.buttons.length > 1">
                        <md-button class="md-icon-button md-mini delete" @click="removeButton(button.id)">
                            <md-icon>delete_outline</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-mini" @click.prevent="moveUpButton(button.id)">
                            <md-icon>arrow_upward</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-mini" @click.prevent="moveDownButton(button.id)">
                            <md-icon>arrow_downward</md-icon>
                        </md-button>
                    </div>
                </a-popover>
            </div>
            <div class="buttons-add" v-if="!previewMode">
                <div class="buttons-add-line"></div>
                <div class="buttons-add-wrapper">
                    <div class="buttons-add-plus" @click="addButton">
                        <span class="material-icons"> add </span>
                    </div>
                    <div class="buttons-add-text">{{ $t("chatbotv2.addButton") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import { generateRandomId } from "../../../../../../../utils/session";
import ActionButtonUpdater from "../../common/ActionButtonUpdater";
import _ from "lodash";

const log = log2("ButtonMessageEditor");
export default {
    name: "ButtonMessageEditor",
    components: { TiptapEditor, ActionButtonUpdater },
    props: {
        value: {
            type: Object,
            required: true,
            default: {
                type: "BUTTON",
                delay: 2,
                message: "",
                buttons: [
                    {
                        id: "",
                        title: "Button",
                        type: "SEND_MESSAGE",
                        payload: {},
                        actions: [], //{type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },
                    },
                ],
            },
        },
        flattedDiagram: {
            type: Array,
            default: () => [],
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        whatsappMode: {
            type: Boolean,
            default: false,
        },
        previewMode: {
            type: Boolean,
            default: false,
        },
        showEmoji: {
            type: Boolean,
            default: true,
        },
        showAttributes: {
            type: Boolean,
            default: true,
        },
        showEmojiPicker: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            editingButtonPopupVisibleMap: {},
            renderId: 0,
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        openEditButtonPopup(buttonId) {
            Object.keys(this.editingButtonPopupVisibleMap).forEach((key) => {
                this.editingButtonPopupVisibleMap[key] = false;
            });
            this.editingButtonPopupVisibleMap[buttonId] = true;
        },
        visibleChange(buttonId, visible) {
            const attributeFormIsEnabled = !!document.getElementById("add-custom-attr-modal");
            log("visibleChange", { buttonId, visible, attributeFormIsEnabled });
            if (!visible && attributeFormIsEnabled) {
                return;
            }
            Object.keys(this.editingButtonPopupVisibleMap).forEach((key) => {
                this.editingButtonPopupVisibleMap[key] = false;
            });
            this.editingButtonPopupVisibleMap[buttonId] = visible;
            this.renderId++;
        },
        addButton() {
            const id = generateRandomId();
            this.openEditButtonPopup(id);
            this.clone = {
                ...this.clone,
                buttons: [
                    ...this.clone.buttons,
                    {
                        id,
                        title: `Button ${this.clone.buttons.length + 1}`,
                        type: "SEND_MESSAGE",
                        payload: {},
                        actions: [], //{type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },
                    },
                ],
            };
        },
        removeButton(id) {
            this.clone = {
                ...this.clone,
                buttons: this.clone.buttons.filter((button) => button.id !== id),
            };
        },
        moveUpButton(id) {
            const index = this.clone.buttons.findIndex((button) => button.id === id);
            if (index > 0) {
                const temp = this.clone.buttons[index - 1];
                this.clone.buttons[index - 1] = this.clone.buttons[index];
                this.clone.buttons[index] = temp;
            }
            this.clone = _.cloneDeep(this.clone);
            // e.preventDefault();
            // e.stopPropagation();
        },
        moveDownButton(id) {
            const index = this.clone.buttons.findIndex((button) => button.id === id);
            if (index < this.clone.buttons.length - 1) {
                const temp = this.clone.buttons[index + 1];
                this.clone.buttons[index + 1] = this.clone.buttons[index];
                this.clone.buttons[index] = temp;
            }
            this.clone = _.cloneDeep(this.clone);
            // e.preventDefault();
            // e.stopPropagation();
        },
        emitValue() {
            if (!_.isEqual(this.clone, this.value)) {
                log("emitValue", this.clone);
                this.$emit("input", this.clone);
            }
        },
    },
    mounted() {
        log("mounted");
    },
    watch: {
        value: {
            handler(val) {
                log("watch value-->", val);
                this.clone = _.cloneDeep(val);
            },
            deep: true,
        },
        clone: {
            handler(val) {
                log("watch clone-->", val);
                this.emitValue();
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.ProseMirror {
    color: #22272d;
    font-size: 16px;
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale;
    font-family: Source Sans Pro, sans-serif;
    font-weight: 400;
}

.button-message-editor {
    width: 240px;
    box-sizing: border-box;
    margin: 0;
    outline: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    position: relative;

    .text-editor-wrapper {
        position: relative;
        user-select: auto;
        width: 100%;

        .text-editor {
            border-radius: 8px 8px 0px 0px;
            border: 1px solid #fff;
            overflow-x: hidden;
            overflow-y: auto;
            transition: border 0.3s;
            height: 150px;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }

            .editable-editor {
                border-radius: 8px 8px 0px 0px;
                overflow-x: hidden;
                overflow-y: auto;

                .ProseMirror {
                    height: 100%;
                }

                &.focused {
                    border: none !important;
                }

                &:focus {
                    border: none !important;
                }

                &:hover {
                    border: none !important;
                    resize: none;
                }
            }

            .editable-editor-wrapper {
                color: #22272d;
                font-size: 16px;
                width: 100%;
                height: calc(100% - 10px);

                .ProseMirror {
                    width: 100%;
                    height: 100%;
                    min-height: 115px;
                    max-height: 165px;
                    padding: 20px 20px 0;
                }
            }
        }
    }

    .buttons-wrapper {
        width: 100%;

        .button-item {
            align-items: center;
            cursor: pointer;
            display: flex;
            height: 42px;
            justify-content: center;
            padding: 0 10px;
            transition: all 0.3s;
            width: 100%;
            background: #fff;
            border-top: 1px solid #e6e6e6;
            position: relative;

            span {
                color: #006cff;
                font-size: 15px;
                font-weight: 600;
                line-height: 19px;
                overflow: hidden !important;
                text-overflow: ellipsis;
                text-align: center;
                //white-space: nowrap;

                &:hover {
                    .button-controls {
                        opacity: 1;
                    }
                }
            }

            &:hover {
                .button-controls {
                    opacity: 1;
                }
            }

            .button-controls {
                align-items: center;
                display: flex;
                opacity: 0;
                position: absolute;
                right: -13px;
                top: -13px;
                transition: opacity 0.3s;
                z-index: 12;

                .md-button {
                    background-color: #fff;
                    align-items: center;
                    border-radius: 100%;
                    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    margin-bottom: 7px;
                    transition: background-color 0.3s;
                    height: 20px;
                    width: 20px;
                    min-height: 20px !important;
                    min-width: 20px !important;

                    .md-icon {
                        color: #006cff;
                        font-size: 16px !important;
                    }

                    &.delete {
                        .md-icon {
                            color: #ff0000;
                        }
                    }
                }
            }
        }

        .buttons-add {
            align-items: center;
            display: flex;
            flex-direction: column;
            margin-bottom: 5px;
            width: 100%;

            .buttons-add-line {
                border-left: 1px dashed #b4c0c7;
                border-right: 1px dashed #b4c0c7;
                height: 28px;
                width: 0;
            }

            .buttons-add-wrapper {
                cursor: pointer;
                position: relative;
                -webkit-transition: opacity 0.3s;
                transition: opacity 0.3s;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .buttons-add-text {
                    color: #475e7a;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 18px;
                    //position: absolute;
                    //top: 1px;
                    //left: 30px;
                    white-space: nowrap;
                    margin-top: 3px;
                    margin-left: 3px;
                }

                .buttons-add-plus {
                    align-items: center;
                    background: #fff;
                    border-radius: 100%;
                    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 19%);
                    display: flex;
                    height: 22px;
                    justify-content: center;
                    transition: background-color 0.6s;
                    width: 22px;

                    &:hover {
                        color: #fff;
                        background: #006cff;
                    }
                }
            }
        }
    }
}
</style>
